<template>
  <div class="secondNav">
    <div class="contentNav width_auto">
      <div class="mr_40">
        <router-link to="/">
          <img src="@/assets/images/logo2.png" alt="">
        </router-link>
      </div>
      <div class="flex flex_a_c">
        <el-input class="searchInputHome" placeholder="请输入内容" @keyup.enter.native="searchPro"
          v-model="keyword">
          <template slot="prefix">
            <el-dropdown @command="searchCommand" trigger="click">
              <span class="cur_p">{{ searchVal }}
                <i class="el-icon-arrow-down cur-poi el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="商品">商品</el-dropdown-item>
                <el-dropdown-item command="店铺">店铺</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template slot="suffix">
            <el-button class="btn_584DFF" @click="searchPro">搜索</el-button>
          </template>
        </el-input>
      </div>

    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'

export default {
  data () {
    return {
      searchVal: '商品',
      keyword: ''
    }
  },
  computed: {
    ...mapGetters([
      'searchObj'
    ])
  },
  mounted () {
    if (this.searchObj.keyword !== undefined) {
      this.keyword = this.searchObj.keyword
      this.searchVal = this.searchObj.searchVal
    }
  },
  methods: {
    ...mapMutations({
      setSearchObj: 'SET_SEARCHOBJ'
    }),
    searchCommand (command) {
      this.searchVal = command
    },
    searchPro () {
      if (!this.keyword) { return this.$message.error('请输入搜索内容') }
      this.setSearchObj({
        keyword: this.keyword,
        searchVal: this.searchVal
      })
      if (this.$route.name !== 'search') {
        this.$router.push({
          path: '/activity/search'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.secondNav {
  width: 100%;
  background-color: #F5F6FA;

  .contentNav {
    height: 132px;
    margin: auto;
    display: flex;
    align-items: center;

  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/secondNav.vue